import { render, staticRenderFns } from "./PaymentUnion.vue?vue&type=template&id=c2855a94&scoped=true"
import script from "./PaymentUnion.vue?vue&type=script&lang=js"
export * from "./PaymentUnion.vue?vue&type=script&lang=js"
import style0 from "./PaymentUnion.vue?vue&type=style&index=0&id=c2855a94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2855a94",
  null
  
)

export default component.exports